import { Heading, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

export function BrandHeading({
  children,
  fontSize = { base: '3xl', sm: '4xl', lg: '6xl' },
  ...props
}) {
  return (
    <Heading
      lineHeight={1.1}
      fontWeight={600}
      fontSize={fontSize}
      mb={7}
      {...props}
      as="h1"
    >
      <Text
        as={'span'}
        position={'relative'}
        display={'inline'}
        backgroundImage={'linear-gradient(transparent 72%, var(--chakra-colors-brand-300) 72%, var(--chakra-colors-brand-300) 94%, transparent 94%)'}
        backgroundSize={'100% 100%'}
        backgroundRepeat={'no-repeat'}
        sx={{
          boxDecorationBreak: 'clone',
          WebkitBoxDecorationBreak: 'clone',
        }}
      >
        {children}
      </Text>
    </Heading>
  );
}

/**
 * 
 * @param {number} changeOffset - The number of words to change the color of starting from the right
 * @param {object} changeStyle - The style to apply to the changed text
 * @param {string} children - The text to display
 * @param {object} props - The props to pass to the heading
 * @param {object} fontSize - The font size to apply to the heading
 * @param {object} props - The props to pass to the heading
 * @param {object} props - The props to pass to the heading
 * @returns 
 */
export function BrandHeading2({
  children,
  fontSize = { base: '3xl', sm: '4xl', lg: '6xl' },
  changeOffset = 0,
  changeStyle,
  as = 'h1',
  ...props
}) {
  const [text, colorText] = splitStringAtOffset(children, changeOffset);
  return (
    <Heading
      lineHeight={1.1}
      fontWeight={600}
      fontSize={fontSize}
      mb={7}
      as={as}
      {...props}
    >
      <Text
        as={'span'}
        position={'relative'}
        display={'inline'}
        backgroundImage={'linear-gradient(transparent 72%, var(--chakra-colors-brand-300) 72%, var(--chakra-colors-brand-300) 94%, transparent 94%)'}
        backgroundSize={'100% 100%'}
        backgroundRepeat={'no-repeat'}
        sx={{
          boxDecorationBreak: 'clone',
          WebkitBoxDecorationBreak: 'clone',
        }}
      >
        {text}
      </Text>
      <Text color="brand.400" {...changeStyle}>
        {colorText}
      </Text>
    </Heading>
  );
}

function splitStringAtOffset(str, wordOffsetFromRight) {
  // Split the string into an array of words
  const words = str.split(' ');

  // Calculate the index of the word at the specified offset from the right
  const index = words.length - wordOffsetFromRight;

  // Join the first part of the array up to the specified index
  const firstPart = words.slice(0, index).join(' ');

  // Join the second part of the array from the specified index
  const secondPart = words.slice(index).join(' ');

  // Return a tuple of the two parts
  return [firstPart, secondPart];
}
